import * as React from "react";
import { observer } from "mobx-react-lite";
import { Button, Form, Input, Radio } from "antd";
import { DeleteOutlined, SisternodeOutlined } from "@ant-design/icons";
import { ExtraTools } from "src/pages/ManagementPage/ExtraTools";
import { WidthLimitedFields } from "src/pages/ManagementPage/WidthLimitedFields";
import { ObjRoleNode, newItemId } from "../../nodes/RoleNode";
import { ZRoleFields } from "../../RolesTab.types";
import { RolesTabStore } from "../../RolesTabStore";
import { isCopyOptions } from "./roleObjFieldOptions";
import styles from "./RoleObjectField.module.less";
import { RoleActionFields } from "./RoleActionFields";
import { RoleCopyFields } from "./RoleCopyFields";

interface PropsRoleObjectField {
  store: RolesTabStore;
  node?: ObjRoleNode;
}

const fieldKey = (key: keyof ZRoleFields) => key;

export const RoleObjectField: React.FC<PropsRoleObjectField> = observer(
  ({ store }) => {
    const form = Form.useFormInstance();
    const isCopy = Form.useWatch(fieldKey("isCopy"), form);

    //   && !node.obj.permissions?.includes(Permission.objDelete)
    // но на момент разработки permissions=null, то есть неизвестно ничего о ролевой модели для данного случая
    return (
      <WidthLimitedFields>
        <Form.Item
          name={fieldKey("name")}
          label="Название роли"
          rules={[{ required: true }]}
        >
          <Input allowClear autoFocus />
        </Form.Item>
        {store.isNewNode && (
          <>
            <Form.Item name={fieldKey("isCopy")}>
              <Radio.Group
                className={styles.radioGroup}
                options={isCopyOptions}
              />
            </Form.Item>
            {isCopy !== undefined &&
              (isCopy ? (
                <RoleCopyFields roleGroups={store.roleGroups} />
              ) : (
                <RoleActionFields />
              ))}
          </>
        )}
      </WidthLimitedFields>
    );
  },
);

export const RoleObjectButtons: React.FC<PropsRoleObjectField> = observer(
  ({ store, node }) => {
    const isNew = node?.obj.id === newItemId;
    const canAddAttr = !isNew;
    const canDelete = true;
    return (
      <ExtraTools>
        <Button
          icon={<SisternodeOutlined />}
          onClick={() => store.safeAddAttr()}
          disabled={!canAddAttr}
          id="addAttrToRole"
        >
          Добавить атрибут
        </Button>
        <Button
          icon={<DeleteOutlined />}
          danger
          onClick={() => {
            store.safeDeleteCurNode();
          }}
          disabled={!canDelete}
        >
          Удалить роль
        </Button>
      </ExtraTools>
    );
  },
);
